import type { Subscription } from '@/types/models.types';

/**
 * Finds and returns the first active author subscription from an array of subscriptions.
 *
 * @param subscriptions - Array of user's subscriptions.
 * @returns The active author subscription or undefined if none exists.
 */
export function findActiveAuthorSubscription(
  subscriptions: Subscription[],
  authorId: number
): Subscription | undefined {
  return subscriptions.find((subscription) => {
    return (
      subscription.active &&
      subscription.author &&
      subscription.author.lookupKey &&
      subscription.author.lookupKey === authorId
    );
  });
}
